<template>
  <form
    class="simple-create-form"
    @submit.prevent="submitForm"
  >
    <h3>
      Opret ny administrationsvej
    </h3>
    <Box>
      <BaseInput
        label="Navn"
        v-model="info.name"
        :disabled="loading"
      />
      <BaseFormField label="Importkode">
        <BaseSelect
          v-model="selectedImportRefferenceCodes"
          placeholder="Vælg importkode"
          class="default"
          tag-position="bottom"
          :options="importCodes"
          :multiple="true"
        />
      </BaseFormField>
      <BaseTextarea
        label="Beskrivelse"
        v-model="info.description"
        :disabled="loading"
      />
      <div class="simple-create-form__inline">
        <BaseButton
          label="Opret administrationsvej"
        />
        <div>
          <BaseSpinner
            height="40px"
            width="40px"
            v-if="loading"
          />
        </div>
      </div>
    </Box>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import BaseFormField from '../../BaseFormField.vue';
import BaseSelect from '../../BaseSelect.vue';
import BaseTextarea from '../../BaseTextarea.vue';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseButton from '../../BaseButton.vue';
import Box from '../../Box.vue';
import BaseInput from '../../BaseInput.vue';
import RouteOfAdministrationService from '../../../services/RouteOfAdministrationService';

export default {
    name: 'CreateRouteOfAdministrationForm',
    components: {
        BaseInput, Box, BaseButton, BaseSpinner, BaseTextarea, BaseSelect, BaseFormField,
    },
    props: {
        importCodes: { type: Array, required: true },
    },
    data() {
        return {
            loading: false,
            info: {
                name: '',
                description: '',
            },
            selectedImportRefferenceCodes: [],
        };
    },
    validations: {
        info: {
            name: { required },
        },
    },
    methods: {
        addProductNumber(productNumber) {
            const exists = this.productNumbers.find(x => x.productNumber === productNumber);

            if (exists) {
                return;
            }

            const format = {
                productNumber,
            };

            this.productNumbers.push(format);
        },
        resetForm() {
            this.info.name = '';
            this.info.description = false;
        },
        async submitForm() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$snotify.error('Ikke alle felter er udfyldt korrekt.');
                return;
            }

            try {
                this.loading = true;

                const payload = await RouteOfAdministrationService.create({ info: this.info, importRefferenceCodes: this.selectedImportRefferenceCodes });

                this.$snotify.success(`${payload.name} er oprettet`);
                this.loading = false;
                this.$emit('created', payload);
                this.resetForm();
            } catch (error) {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.simple-create-form {
    max-width: 500px;
    margin-top: 50px;

    &__inline {
        display: flex;

        svg {
            margin-left: 10px;
        }
    }
}
</style>
